export const FEATURE_NAME = '@zerops/zerops/feature/web-public-routing-pop';
